<script>
import axios from 'axios'
import sessionStore from '@/stores/session-store.js'
import serviceProviderStore from '@/stores/service-provider-store.js'
import RedirectToLockersOrDeliveries from '@/mixins/redirect-to-lockers-or-deliveries.js'

export default {
  name: 'SessionSSOCallback',
  mixins: [RedirectToLockersOrDeliveries],
  data() {
    return {
      blocker: false,
      error: null,
    }
  },
  mounted() {
    const code = ((this.$route || {}).query || {}).code
    if (code) this.getToken(code)
  },
  methods: {
    getToken(code) {
      this.blocker = true
      const url = 'https://login.pwc.com/openam/oauth2/access_token'
      const clientId = 'urn:pwc.pwa.collectomate.io'
      const clientSecret = 'PqtVDCZcFZYpMK25yzZH'
      const redirectUri = 'https://pwc.pwa.collectomate.io/sso-sign-in'
      const grantType = 'authorization_code'

      axios({
        method: 'post',
        url: url,
        headers: { 'Content-type': 'application/x-www-form-urlencoded' },
        data: `code=${code}&client_id=${clientId}&client_secret=${clientSecret}&redirect_uri=${redirectUri}&grant_type=${grantType}`,
      })
        .then(response => {
          if (response && response.status === 200 && response.data && response.data.accessToken) {
            this.getUserInfo(response.data.accessToken)
          }
        })
        .catch(error => {
          console.log('getToken error', error)
          this.blocker = false
        })
    },
    getUserInfo(token) {
      // axios({
      //   method: 'get',
      //   url: 'https://oauth.mocklab.io/userinfo',
      //   headers: { Authorization: `Bearer ${token}` },
      // })
      axios({
        method: 'get',
        url: `https://login.pwc.com/openam/oauth2/userinfo`,
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(response => {
          if (response && response.status === 200 && response.data) {
            this.openAmSignIn(response.data)
          }
        })
        .catch(error => {
          console.log('getUserInfo error', error)
          this.blocker = false
        })
    },
    openAmSignIn(data) {
      axios({
        method: 'post',
        url: '/auth/open_am_sign_in',
        headers: { Authorization: '' },
        data: {
          email: data.email,
          service_provider_id: serviceProviderStore.getters.id,
        },
      })
        .then(response => {
          if (response && response.status === 200 && response.data) {
            sessionStore.commit('setData', response.data.token)
            sessionStore.commit('setUser', response.data.user)
            this.redirectToLockersOrDeliveries()
          }
        })
        .catch(error => {
          this.error = error.response.data.errors
          sessionStore.commit('setData', null)
          console.log('openAmSignIn error', error.response)
        })
        .finally(() => {
          this.blocker = false
        })
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
</script>
<template lang="pug">
.sso-callback
  .sso-info
    h2.text-primary SSO LOGIN IN PROGRESS
    span.text-danger(v-if="!!error") {{ error }}
  blocker(v-if="blocker")
</template>

<style scoped lang="scss">
.sso-callback {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #67c9bb;
  background: linear-gradient(135deg, #67c9bb 0%, #009bde 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  .sso-info {
    background: white;
    padding: 20px 40px;
    border-radius: 1rem;
    text-align: center;
  }
}
</style>
